import Collapse from "@mui/material/Collapse";
import Link from "next/link";
import { useState } from "react";
import { FiArrowRight, FiChevronDown, FiChevronUp } from "react-icons/fi";
import RegistrationBox from "../common/registration_box";
import SectionTitle from "../common/section_title";
import styles from "./styles/why_choose.module.scss";

const data = [
  {
    id: 1,
    name: "Study",
    children: [
      { link: "#", title: "Student Dashboard" },
      { link: "#", title: "Countries" },
      { link: "#", title: "Counsellors" },
      { link: "#", title: "Mentor" },
      { link: "#", title: "Search" },
      { link: "#", title: "Exams" },
      { link: "#", title: "Admissions" },
      { link: "#", title: "Online Education Fair" },
      { link: "#", title: "Forum" },
      { link: "#", title: "Online TV" },
      { link: "#", title: "News" },
      { link: "#", title: "Blog" },
    ],
  },
  {
    id: 2,
    name: "eLearning",
    children: [
      { link: "#", title: "Student & Instructors Dashboard" },
      { link: "#", title: "Online Courses" },
      { link: "#", title: "eBooks" },
      { link: "#", title: "Live Sessions" },
      { link: "#", title: "IELTS" },
      { link: "#", title: "TOEFL" },
      { link: "#", title: "GMAT" },
      { link: "#", title: "GRE" },
      { link: "#", title: "SAT" },
      { link: "#", title: "ACT" },
    ],
  },
  {
    id: 3,
    name: "Accommodation",
    children: [
      { link: "#", title: "Search Accommodation" },
      { link: "#", title: "Save Accommodation" },
      { link: "#", title: "Compare Listing" },
      { link: "#", title: "Nearby" },
      { link: "#", title: "Search by Map" },
      { link: "#", title: "Agents and Agencies" },
      { link: "#", title: "Agents and Agencies" },
    ],
  },
  {
    id: 4,
    name: "Jobs",
    children: [
      { link: "#", title: "Effective Job Search" },
      { link: "#", title: "Jobs Nearby" },
      { link: "#", title: "Jobs Search with Map" },
      { link: "#", title: "Application Tracking" },
      { link: "#", title: "Email Alerts" },
      { link: "#", title: "Free Job Submission" },
      { link: "#", title: "Profile Builder" },
      { link: "#", title: "Resume Manager" },
      { link: "#", title: "Shortlist Jobs" },
    ],
  },
];

export const WhyChoose = () => {
  const [openItem, setOpen] = useState([]);

  const handleCollapse = (val) => {
    const item = [...openItem];
    const index = item.indexOf(val);
    if (index > -1) {
      item.splice(index, 1);
    } else {
      item.push(val);
    }
    setOpen(item);
  };

  return (
    <section className={styles.section_why_choose}>
      <div className="container">
        <SectionTitle
          // shadow_text="YOUR GUIDANCE TO CONNECT WITH MENTORS"
          title="Why Choose UniSearch"
        >
          <p>
            The complete solution for Students & <br />
            Universities
          </p>
        </SectionTitle>

        <div className={styles.choose_wrapper}>
          <div className={styles.choose_list_wrapper}>
            {data.map((item) => {
              return (
                <div key={item.id}>
                  <div className={styles.title}>
                    <span>{item.name}</span>
                  </div>
                  {item.children.map((child, i) => (
                    <Link legacyBehavior key={i} href="#">
                      <a>
                        <FiArrowRight />
                        <span>{child.title}</span>
                      </a>
                    </Link>
                  ))}
                </div>
              );
            })}
          </div>

          {/* For mobile */}
          <div className={`${styles.choose_list_wrapper} ${styles.mobile}`}>
            {data.map((item) => {
              return (
                <div key={item.id}>
                  <div
                    className={styles.title}
                    onClick={(e) => handleCollapse(item.id)}
                  >
                    <span>{item.name}</span>
                    {openItem.indexOf(item.id) > -1 ? (
                      <FiChevronUp />
                    ) : (
                      <FiChevronDown />
                    )}
                  </div>
                  <Collapse
                    in={openItem.indexOf(item.id) > -1}
                    timeout="auto"
                    unmountOnExit
                  >
                    {item.children.map((child, i) => (
                      <Link legacyBehavior key={i} href="#">
                        <a>
                          <FiArrowRight />
                          <span>{child.title}</span>
                        </a>
                      </Link>
                    ))}
                  </Collapse>
                </div>
              );
            })}
          </div>
          {/* For mobile end */}

          <RegistrationBox />
        </div>
      </div>
      <div className={styles.background_color}></div>
    </section>
  );
};

export default WhyChoose;
